import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, PlatformPublicLayout, Text } from '@topconagriculture/react-components';
import { makeStyles } from '@material-ui/core';
import { TapTheme } from '@topconagriculture/theme';

import { config } from '../../config';

const useStyles = makeStyles((theme: TapTheme) => ({
  root: {
    width: '100vw',
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 10000000,
    overflow: 'disable',
  },
  menuSection: {
    width: 'auto',
  },
  pageContent: {
    zIndex: 110,
    position: 'relative',
    background: theme.color.background.light,
    maxWidth: 400,
    width: '100%',
    borderRadius: theme.common.borderRadius.default,
    boxShadow: '0 24px 24px 0 rgba(0, 0, 0, 0.3), 0 0 24px 0 rgba(0, 0, 0, 0.22)',
    marginBottom: 70,
    padding: 50,
    textAlign: 'center',
  },
}));

const IsMobile: React.FC = () => {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const checkViewportWidth = () => {
      const isMobile = window.innerWidth < 768;
      const dismissed = localStorage.getItem('onlyDesktopDismissed') === 'true';
      setIsVisible(isMobile && !dismissed);
    };

    checkViewportWidth();
    window.addEventListener('resize', checkViewportWidth);

    return () => {
      window.removeEventListener('resize', checkViewportWidth);
    };
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('onlyDesktopDismissed', 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }
  return (
    <div className={classes.root} style={{ width: window.innerWidth, height: window.innerHeight }}>
      <PlatformPublicLayout imagesBaseUrl={config.RESOURCES_BASE_URL} tenantName={config.TENANT_NAME}>
        <div className={classes.pageContent}>
          <div>
            <Text size={16}>
              {t('app:mobile_error_description')}
              <br />
              <a href={window.location.href} style={{ textDecoration: 'underline' }}>
                {window.location.origin}
              </a>
            </Text>
          </div>
          <div style={{ marginTop: 20 }}>
            <Text size={16}>{t('app:mobile_error_fallback')}</Text>
            <div style={{ marginTop: 20 }}>
              <Button onClick={handleDismiss} label={t('common:close')} />
            </div>
          </div>
        </div>
      </PlatformPublicLayout>
    </div>
  );
};

export default IsMobile;
